import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { selectDataMatchOther } from 'pages/profile/connect/selectors';
import { pluralize } from 'utils/string-utils';

import { getBookedByNumberToDisplay } from '../../helpers/recent-bookings-helpers';

import {
  RecentBookingsIcon,
  RecentBookingsText,
  RecentBookingsWrapper,
} from './styled-components';

const RecentBookings = ({ bookedByPastMonth, inNetwork, invertTextColor }) => {
  const { insurance } = useSelector(selectDataMatchOther);
  const insuranceIsVisible = Boolean(insurance?.provider && inNetwork);

  const bookedByNumberToDisplay = useMemo(
    () => getBookedByNumberToDisplay(bookedByPastMonth),
    [bookedByPastMonth],
  );

  return (
    <RecentBookingsWrapper>
      <RecentBookingsIcon aria-hidden />
      <RecentBookingsText $invertTextColor={invertTextColor}>
        {pluralize(bookedByNumberToDisplay, 'person', 'people')}
        {insuranceIsVisible && ` with ${insurance.provider}`} booked in the past
        month
      </RecentBookingsText>
    </RecentBookingsWrapper>
  );
};

RecentBookings.propTypes = {
  bookedByPastMonth: PropTypes.number,
  inNetwork: PropTypes.bool,
  invertTextColor: PropTypes.bool,
};

export default RecentBookings;
